// @ts-check
import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import cliniciansReducer, { initialState as cliniciansInitialState } from './reducers/clinicians';
import patientsReducer, { initialState as patientsInitialState } from './reducers/patients';
import rescheduleReducer, { initialState as rescheduleInitialState } from './reducers/reschedule';
import participantReducer, { initialState as participantInitialState } from './reducers/participant';
import authReducer, { initialState as authInitialState } from './reducers/auth';
import appointmentReducer, { initialState as appointmentInitialState } from './reducers/appointment';

const bindMiddleware = (middleware) => {
  if (process.env.NODE_ENV !== 'production' && typeof window !== 'undefined') {
    return composeWithDevTools(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

export const initialState = {
  auth: authInitialState,
  patients: patientsInitialState,
  clinicians: cliniciansInitialState,
  reschedule: rescheduleInitialState,
  participant: participantInitialState,
  appointment: appointmentInitialState
};

export type ReduxStore = typeof initialState;

const appReducer = combineReducers({
  auth: authReducer,
  clinicians: cliniciansReducer,
  patients: patientsReducer,
  reschedule: rescheduleReducer,
  participant: participantReducer,
  appointment: appointmentReducer
});

export const rootReducer = (state, action) => appReducer(state, action);

let globalStore;

export const getGlobalStore = () => globalStore;

export default function initializeStore(startState = initialState) {
  globalStore = createStore(rootReducer, startState, bindMiddleware([thunkMiddleware]));

  if (typeof window !== 'undefined') {
    globalThis.GlobalStore = globalStore;
  }

  return globalStore;
}
